/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { calculateDiscountItemGroupUnionModifierSchema } from "./calculateDiscountItemGroupUnionModifierSchema.ts";
import { calculateDiscountItemModifierSchema } from "./calculateDiscountItemModifierSchema.ts";
import { discountItemSchema } from "./discountItemSchema.ts";

export const calculateDiscountItemSchema = z
	.object({
		id: z.uuid(),
		amount: z.int().min(1),
		size: z.uuid().nullish(),
		comment: z.string().max(120).nullish(),
		modifiers: z.array(calculateDiscountItemModifierSchema).nullish(),
		group_modifiers: z.array(calculateDiscountItemGroupUnionModifierSchema).nullish(),
		front_item_id: z.uuid().optional(),
		marking_code: z.string().nullish(),
		price: z.string(),
		base_price: z.string().describe("Цена за единицу без акции блюда; совпадает с price, если акции нет."),
		total_price: z.string(),
		new_price: z.string(),
		total_new_price: z.string(),
		discounts: z.array(discountItemSchema).nullable(),
	})
	.describe("Уменьшение стоимости модификаторов позиции на бесплатные единицы.");
